export class ClientPermission {
    public static readonly read: string = 'clientmanager:read:client';
    public static readonly write: string = 'clientmanager:write:client';
    public static readonly admin: string = 'clientmanager:admin:client';
}
